import { render, staticRenderFns } from "./RequestConfirmation.vue?vue&type=template&id=7b904b84&"
import script from "./RequestConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RequestConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports